<div class="form">
	<zk-input [zkStatus]="formStatus.displayName">
		<input
			zkInputRef
			(input)="checkFields()"
			[(ngModel)]="formData.displayName"
			placeholder="{{ 'SESSION.USERFORM.USERNAME_PLACEHOLDER' | translate }}"
		/>
		<span zkInputLabel>{{ 'SESSION.USERFORM.USERNAME' | translate }}</span>
		<span
			zkInputMessage
			[class.zk-hidden]="formStatus.displayName === 'default'"
		>
			<ng-container>
				{{ 'SESSION.USERFORM.ERROR.NAME_REQUIRED' | translate }}
			</ng-container>
		</span>
	</zk-input>

	<div class="form-row">
		<zk-input [zkStatus]="formStatus.default">
			<input
				zkInputRef
				[(ngModel)]="formData.birthdate"
				[dropSpecialCharacters]="false"
				[leadZeroDateTime]="true"
				[clearIfNotMatch]="true"
				mask="d0/M0/0000"
				placeholder="DD/MM/AAAA"
			/>
			<span zkInputLabel>{{ 'SESSION.USERFORM.BIRTHDATE' | translate }}</span>
		</zk-input>

		<zk-dropdown
			[(ngModel)]="formData.gender"
			label="Gênero"
			class="gender-dropdown"
			placeholder="Selecione"
			[options]="genders"
			[zkStatus]="formStatus.default"
		></zk-dropdown>
	</div>

	<div class="form-row">
		<zk-input [zkStatus]="formStatus.default">
			<input
				zkInputRef
				[(ngModel)]="formData.city"
				placeholder="{{ 'SESSION.USERFORM.CITY_PLACEHOLDER' | translate }}"
			/>
			<span zkInputLabel>{{ 'SESSION.USERFORM.CITY' | translate }}</span>
		</zk-input>

		<zk-dropdown
			[(ngModel)]="formData.state"
			[disabled]="false"
			[label]="'Estado'"
			[options]="states"
			[zkStatus]="formStatus.default"
		></zk-dropdown>
	</div>
	<zk-input
		[zkStatus]="formStatus.fiscalId === 'empty' ? 'error' : formStatus.fiscalId"
	>
		<input
			zkInputRef
			[(ngModel)]="formData.fiscalId"
			(input)="checkFields()"
			mask="000.000.000-00"
			placeholder="000.000.000-00"
		/>
		<span zkInputLabel>{{ 'SESSION.USERFORM.FISCAL_ID' | translate }}</span>
		<span zkInputMessage [class.zk-hidden]="formStatus.fiscalId === 'default'">
			<ng-container *ngIf="formStatus.fiscalId === 'empty'">
				{{ 'SESSION.USERFORM.ERROR.FISCAL_ID_REQUIRED' | translate }}
			</ng-container>
			<ng-container *ngIf="formStatus.fiscalId === 'error'">
				{{ 'SESSION.USERFORM.ERROR.FISCAL_ID_INVALID' | translate }}
			</ng-container>
		</span>
	</zk-input>
</div>

<div class="footer">
	<freud-button
		color="secondary"
		type="button"
		size="sm"
		(click)="handleCancel()"
	>
		Cancelar
	</freud-button>
	<freud-button
		color="primary"
		type="button"
		size="sm"
		[loading]="loading"
		(click)="handleUpdate()"
	>
		Salvar
	</freud-button>
</div>
